import Icon from 'src/components/Icon'
import styled, { css } from 'styled-components'

import { mq, sizes } from '../../../theme'

import { CheckboxVariant } from './types'

export const Group = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  padding: 0;
  margin: 0;

  @media ${mq(sizes.desktop)} {
    justify-content: center;
    flex-direction: row;
  }
`

export const Legend = styled.legend`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`

export const CheckContainer = styled.div`
  display: flex;
  position: absolute;
  left: 1.45rem;
  flex-shrink: 0;
  background: white;
  border-radius: 50%;
  border: 0.1rem solid ${({ theme }) => theme.colors.greenEmerald};
  box-shadow: inset 2px 2px 5px 1px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  height: 2rem;
  width: 2rem;
  @media ${mq(sizes.desktop)} {
    height: 1.8rem;
    width: 1.8rem;
  }
`

export const Check = styled.div`
  display: none;
  border-radius: 50%;
  transform: translate(4px, 4px);
  height: 1rem;
  width: 1rem;
  background: ${({ theme }) => theme.colors.pureBlack};
  @media ${mq(sizes.desktop)} {
    transform: translate(4px, 4px);
    height: 0.8rem;
    width: 0.8rem;
  }
`

export const CheckboxWrapper = styled.div<{
  checked: boolean
  $variant: CheckboxVariant
}>`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16};

  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: ${({ $variant }) =>
    $variant === CheckboxVariant.target ? '3.8rem' : '3.5rem'};
  width: auto;
  border-radius: ${({ $variant }) =>
    $variant === CheckboxVariant.blue ? '1rem' : '2rem'};
  padding: 0 0.5rem;
  outline: 0 none;
  border: ${({ $variant }) =>
      $variant === CheckboxVariant.target ? '0.2rem' : '0.1rem'}
    solid
    ${({ theme, $variant, checked }) =>
      $variant === CheckboxVariant.blue
        ? theme.colors.tuftBlue
        : $variant === CheckboxVariant.target && !checked
        ? theme.colors.tuftBlue
        : $variant === CheckboxVariant.target && checked
        ? theme.colors.denimBlue
        : theme.colors.greenEmerald};
  background: ${({ checked, theme, $variant }) =>
    checked
      ? $variant === CheckboxVariant.blue
        ? theme.colors.denimBlue
        : $variant === CheckboxVariant.target
        ? theme.colors.denimBlue
        : theme.colors.greenEmerald
      : theme.colors.pureWhite};
  align-items: center;
  justify-content: center;
  user-select: none;

  ${({ checked }) =>
    checked &&
    css`
      ${Check} {
        display: flex;
      }
    `}

  &:hover {
    cursor: pointer;
  }

  &:not(:first-of-type) {
    margin-top: 1.5rem;
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_condensed_14};

    height: ${({ $variant }) =>
      $variant === CheckboxVariant.target ? '3.8rem' : '3.7rem'};

    &:not(:first-of-type) {
      margin-top: 0;
      margin-left: 3rem;
    }
  }
`
export const Checkbox = styled.input`
  display: none;
`

export const Label = styled.label<{ $variant: CheckboxVariant }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 100%;
  padding-left: ${({ $variant }) =>
    $variant === CheckboxVariant.blue
      ? '1.5rem'
      : $variant === CheckboxVariant.target
      ? '4rem'
      : '3.5rem'};
  padding-right: ${({ $variant }) =>
    $variant === CheckboxVariant.blue
      ? '1.5rem'
      : $variant === CheckboxVariant.target
      ? '1rem'
      : '1rem'};

  &:hover {
    cursor: pointer;
  }
`

export const PlusContainer = styled.div<{ checked: boolean }>`
  display: flex;
  position: absolute;
  left: -0.25rem;
  background-color: ${({ checked, theme }) =>
    checked ? theme.colors.pureWhite : theme.colors.denimBlue};
  padding: 0.9rem;
  border-radius: 50%;
  transition: 0.15s;

  & span {
    color: ${({ checked, theme }) =>
      checked ? theme.colors.denimBlue : theme.colors.pureBlack};
    transition: transform 0.15s, color 0.15s;
    transform: rotate(${({ checked }) => (checked ? 45 : 0)}deg);
  }
`

export const PlusIcon = styled(Icon)`
  height: 2rem;
  width: 2rem;
  transition: transform 0.15s, color 0.15s;
`
